var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingLayersList)?_c('div',[_c('NavBar',{attrs:{"noleft":"true"}}),_c('LayerView',{attrs:{"layer_id":_vm.id,"project_id":_vm.hashid}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }